export default __webpack_public_path__ + "static/media/pictogramUnlock64.7f963f20.svg";